import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { UserAuthLayout } from "../../components/user/UserAuthLayout";
import { formatApiErrorDetail } from "../../context/UserAuthContext";
import { API_URL } from "../../config";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) {
      toast.error("As passwords não coincidem.");
      return;
    }
    if (pw.length < 8) {
      toast.error("A password tem de ter pelo menos 8 caracteres.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/api/users/reset-password`, { token, new_password: pw });
      toast.success("Password actualizada com sucesso. Entre na sua conta.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao actualizar password");
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <UserAuthLayout title="Link inválido" subtitle="O link de reposição não é válido.">
        <p className="text-sm text-zinc-400 mb-4">Pode pedir um novo link a partir da página de login.</p>
        <Link to="/esqueci-password" className="btn-primary block text-center" data-testid="link-forgot-again">
          Pedir novo link
        </Link>
      </UserAuthLayout>
    );
  }

  return (
    <UserAuthLayout
      title="Nova password"
      subtitle="Defina uma password nova para a sua conta."
      footer={<><Link to="/login" className="text-amber-400 hover:text-amber-300">← Voltar a entrar</Link></>}
    >
      <form onSubmit={handleSubmit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label htmlFor="pw" className="text-zinc-300">Nova password</Label>
          <Input id="pw" type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Mínimo 8 caracteres" className="input-dark mt-1.5" autoFocus autoComplete="new-password" data-testid="reset-pw" />
        </div>
        <div>
          <Label htmlFor="pw2" className="text-zinc-300">Confirmar password</Label>
          <Input id="pw2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repita a password" className="input-dark mt-1.5" autoComplete="new-password" data-testid="reset-pw2" />
        </div>
        <Button type="submit" disabled={submitting || !pw || !pw2} className="btn-primary w-full" data-testid="reset-submit">
          {submitting ? "A actualizar..." : "Definir nova password"}
        </Button>
      </form>
    </UserAuthLayout>
  );
}
